//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const TargetedSubmissionUpgrades: FeatureFlag = {"Id":"TargetedSubmissionUpgrades","Label":"Allow targeting submission definition upgrades","Impact":"Allow users to upgrade submissions to definition other than the latest one","Mode":3,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
